import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FormRow, FormRowLabel, FormRowMessage, FormRowText, FormCheckbox, GdprCheckboxes, Alert, TitleStack, BlockButton, Card } from "fiver-react-ui-components";
const StyledWrapper = styled.div``;
const StyledButton = styled.button`
  display: inline-block;
  font-size: inherit;
  padding: 0;
  color: ${props => props.theme.colorAccent === "#000000" ? props.theme.colorAccentText : props.theme.colorAccent};
`;
const StyledSmallButton = styled.button`
  display: inline-block;
  font-size: 14px;
  padding: 0;
  color: ${props => props.theme.colorAccent === "#000000" ? props.theme.colorAccentText : props.theme.colorAccent};
  margin-bottom: 1rem;
`;
const StyledCardHeaderSmall = styled.div`
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;
const StyledUl = styled.ul`
  margin: 0 0 2rem;
  padding: 0.75rem 0 0 1rem;
`;
const StyledLi = styled.li`
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  line-height: 1.3;
`;

const SignupStep = ({
  translations,
  isSubmitting,
  onPageButtonClicked,
  onStepClicked,
  setValues,
  isStepValid,
  values,
  errors,
  dirty,
  handleChange,
  signupError,
  termsSlug,
  privacySlug,
  handleBlur,
  useAssetsCdn,
  showHasTotoAccountCheckbox,
  hideGdprCheckboxes,
  hidePushNotifcationCheckbox,
  hideSmsCheckbox,
  hideEmailCheckbox,
  hideCheckAllCheckbox,
  gameRulesSlug,
  tenantDetails,
  isNonUk,
  isSavingPicks,
  hasCustomPrivacy
}) => {
  useEffect(() => {
    window.xtremepush("tag", "registration_contact_permissions", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));

    if (values.country !== "United Kingdom") {
      setValues({ ...values // emailNotificationsAccepted: true,

      });
    }

    if (!isNonUk) {
      setValues({ ...values,
        inAppNotificationsAccepted: false,
        smsNotificationsAccepted: false,
        emailNotificationsAccepted: false,
        agreedPrivacy: false,
        agreedTerms: false
      });
    } else {
      setValues({ ...values,
        emailNotificationsAccepted: false,
        partnerNotificationAccepted: false,
        affiliateNotificationAccepted: false,
        hasTotoAccount: false
      });
    }
  }, []);
  const [checkAll, setCheckAll] = useState(false);

  const handleCheckAllChecked = e => {
    if (e.target.checked) {
      setCheckAll(true);
      setValues({ ...values,
        inAppNotificationsAccepted: true,
        smsNotificationsAccepted: true,
        emailNotificationsAccepted: true,
        agreedTerms: true,
        agreedPrivacy: true
      });
    } else {
      setCheckAll(false);
      setValues({ ...values,
        inAppNotificationsAccepted: false,
        smsNotificationsAccepted: false,
        emailNotificationsAccepted: false,
        agreedTerms: false,
        agreedPrivacy: false
      });
    }
  };

  const handleCheckAllCheckedNonUk = e => {
    if (e.target.checked) {
      setCheckAll(true);
      setValues({ ...values,
        emailNotificationsAccepted: true,
        agreedTerms: true
      });
    } else {
      setCheckAll(false);
      setValues({ ...values,
        emailNotificationsAccepted: false,
        agreedTerms: false
      });
    }
  };

  const confirmTerms = () => {
    if (values.country !== "United Kingdom") {
      setValues({ ...values,
        agreedPrivacy: true
      });
      onStepClicked(4);
    } else {
      onStepClicked(4);
    }
  };

  const handleEmailConsent = e => {
    if (e.target.checked) {
      setValues({ ...values,
        emailNotificationsAccepted: true
      });
    } else {
      setValues({ ...values,
        emailNotificationsAccepted: false
      });
    }
  };

  const openRedirect = () => {
    window.open(translations.privacyUrl, '_blank').focus();
  };

  const NonUkPreferences = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(TitleStack, {
      title: `${translations.step} 4`,
      subtitle: translations.preferences
    }), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      isSmallerText: true,
      name: "emailNotificationsAccepted",
      alignItems: "center",
      checked: values.emailNotificationsAccepted,
      label: translations.emailNotificationsAccepted.replace("$1", tenantDetails?.complianceName),
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
        handleEmailConsent(e);
      },
      onBlur: handleBlur
    })), tenantDetails?.partnerName && /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      isSmallerText: true,
      name: "partnerNotificationAccepted",
      alignItems: "center",
      checked: values.partnerNotificationAccepted,
      label: `${translations.partnerLabel} ${tenantDetails?.partnerName}.`,
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), tenantDetails?.affiliateName && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormCheckbox, {
      isSmallerText: true,
      name: "affiliateNotificationAccepted",
      alignItems: "center",
      checked: values.affiliateNotificationAccepted,
      label: `${translations.affiliateLabel} ${tenantDetails?.affiliateName}`,
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), showHasTotoAccountCheckbox && /*#__PURE__*/React.createElement(FormCheckbox, {
      isSmallerText: true,
      name: "hasTotoAccount",
      alignItems: "center",
      checked: values.hasTotoAccount,
      label: `${translations.hasTotoAccountCheckbox.replace("$1", tenantDetails?.complianceName)}.`,
      onChange: handleChange,
      onBlur: handleBlur
    })), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(StyledCardHeaderSmall, null, translations.termsAndPrivacy), /*#__PURE__*/React.createElement(FormRowLabel, null, translations.byJoiningMessage), /*#__PURE__*/React.createElement(StyledUl, null, /*#__PURE__*/React.createElement(StyledLi, null, translations.over18Message), /*#__PURE__*/React.createElement(StyledLi, null, translations.iAgree, " ", /*#__PURE__*/React.createElement(StyledButton, {
      type: "button",
      onClick: () => onPageButtonClicked(termsSlug, "General Terms", useAssetsCdn)
    }, translations.generalTerms), " ", translations.and, " ", /*#__PURE__*/React.createElement(StyledButton, {
      type: "button",
      onClick: () => onPageButtonClicked(gameRulesSlug, translations.gameRules, useAssetsCdn)
    }, translations.gameRules)), /*#__PURE__*/React.createElement(StyledLi, null, translations.privacyPolicyMessage, " ", /*#__PURE__*/React.createElement(StyledButton, {
      type: "button",
      onClick: () => {
        if (hasCustomPrivacy) {
          openRedirect();
        } else {
          onPageButtonClicked(privacySlug, "Privacy Policy", useAssetsCdn);
        }
      }
    }, translations.privacyPolicy))), /*#__PURE__*/React.createElement(FormRowMessage, {
      margin: "0 0 1rem",
      isVisible: signupError !== undefined
    }, signupError), /*#__PURE__*/React.createElement(BlockButton, {
      type: "submit",
      isSuccess: true,
      isLoading: isSubmitting || isSavingPicks,
      disabled: !isStepValid,
      style: {
        marginBottom: "1rem"
      } // onClick={() => confirmTerms()}

    }, translations.joinNow), /*#__PURE__*/React.createElement(BlockButton, {
      onClick: () => onStepClicked(2)
    }, translations.back)));
  };

  const UkPreferences = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(TitleStack, {
      title: `${translations.step} 4`,
      subtitle: translations.preferences
    }), /*#__PURE__*/React.createElement(StyledCardHeaderSmall, null, translations.termsConditions), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      name: "agreedTerms",
      alignItems: "center",
      isSmallerText: true,
      checked: values.agreedTerms,
      label: translations.confirmTermsConditions,
      onChange: e => {
        window.xtremepush("tag", "Profile.TermsAndConditions", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), /*#__PURE__*/React.createElement(StyledSmallButton, {
      type: "button",
      onClick: () => onPageButtonClicked(termsSlug, translations.termsConditions, useAssetsCdn)
    }, translations.termsConditions), /*#__PURE__*/React.createElement(StyledCardHeaderSmall, null, translations.privacyCookies), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      isSmallerText: true,
      name: "agreedPrivacy",
      alignItems: "center",
      checked: values.agreedPrivacy,
      label: translations.confirmPrivacyPolicy,
      onChange: e => {
        window.xtremepush("tag", "Profile.TermsAndConditions", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), /*#__PURE__*/React.createElement(StyledSmallButton, {
      type: "button",
      onClick: () => onPageButtonClicked(privacySlug, translations.privacyCookies, useAssetsCdn)
    }, translations.privacyCookies), /*#__PURE__*/React.createElement(StyledCardHeaderSmall, null, translations.marketing), !hideGdprCheckboxes && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GdprCheckboxes, {
      hidePushNotifcationCheckbox: hidePushNotifcationCheckbox,
      hideSmsCheckbox: hideSmsCheckbox,
      hideEmailCheckbox: hideEmailCheckbox,
      message: translations.confirmMarketing,
      inAppNotificationsAccepted: values.inAppNotificationsAccepted,
      smsNotificationsAccepted: values.smsNotificationsAccepted,
      emailNotificationsAccepted: values.emailNotificationsAccepted,
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    }), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormRowText, null, translations.messageConsent)), !hideCheckAllCheckbox && /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      isSmallerText: true,
      name: "checkAll",
      alignItems: "center",
      checked: checkAll && values.agreedTerms && values.agreedPrivacy && values.inAppNotificationsAccepted && values.smsNotificationsAccepted && values.emailNotificationsAccepted,
      label: translations.confirmAgreeAll,
      onChange: handleCheckAllChecked,
      onBlur: handleBlur
    }))), errors.agreedTerms || errors.agreedPrivacy ? /*#__PURE__*/React.createElement(Alert, {
      isDanger: true,
      margin: "0 0 1rem"
    }, translations.messageTermsPrivacy) : null, /*#__PURE__*/React.createElement(BlockButton, {
      isLoading: isSubmitting || isSavingPicks,
      disabled: !isStepValid || !dirty,
      style: {
        marginBottom: "1rem"
      },
      onClick: () => confirmTerms()
    }, translations.next), /*#__PURE__*/React.createElement(BlockButton, {
      onClick: () => onStepClicked(2)
    }, translations.back)));
  };

  return /*#__PURE__*/React.createElement(StyledWrapper, null, isNonUk ? /*#__PURE__*/React.createElement(NonUkPreferences, null) : /*#__PURE__*/React.createElement(UkPreferences, null));
};

export default SignupStep;